<template>
  <v-card>
    <!-- Card Title -->
    <v-card-title class="font-weight-medium secondary--text primary">
      Pending History of Applicant - {{ applicantId }}
      <v-spacer></v-spacer>
      <v-btn small icon @click="$emit('closeDialog')">
        <v-icon small color="secondary">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <!-- Card Content -->
    <v-card-text class="pa-0">
      <v-timeline dense class="py-0">
        <v-timeline-item
          v-for="(event, ind) in pendings"
          :icon="ind !== 0 ? 'mdi-check' : ''"
          :key="ind"
          small
          class="py-2"
        >
          <div class="text-body-2 pa-0">
            <span class="font-weight-bold primary--text"
              >{{ event.user.name }}
            </span>
            <span class="font-weight-medium text-primary"
              >{{ " - " }} {{ event.inserted_at }}</span
            >
          </div>
          <div class="font-weight-bold text-primary">
            {{ event.reason }}
          </div>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  components: {},
  data: () => ({}),
  props: {
    pendings: {
      type: Array,
      required: true,
    },
    applicantId: {
      type: String,
      required: true,
    },
  },
  watch: {},
  async created() {},
  methods: {},
  computed: {},
};
</script>
